module.exports = {
  context: {
    searchButton: {
      ariaLabel: 'Search'
    },
    nodes: [
      {
        title: 'Language',
        children: [
          {
            title: 'English',
            value: 'en'
          },
          {
            title: 'Spanish',
            value: 'es'
          }
        ]
      }
    ],
    donate: {
      text: 'Donate',
      url: 'https://google.com',
      class: 'primary'
    },
    contact: {
      text: 'Contact',
      url: 'https://google.com'
    }
  }
}
